module.exports = __webpack_public_path__ + "static/fonts/Nexa_Regular.007b563.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Nexa/Nexa_Regular.otf
// module id = Qn1R
// module chunks = 3